/**
 * Utility to convert relative upload URLs to absolute URLs
 * 
 * The backend returns relative URLs like `/uploads/content/product/...`
 * These need to be converted to absolute URLs for proper display in production
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Convert a potentially relative image URL to an absolute URL
 * @param {string} url - The image URL (can be relative or absolute)
 * @returns {string} - The absolute URL
 */
export const getImageUrl = (url) => {
  if (!url) return '';
  
  // If it's already an absolute URL (starts with http:// or https://), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it's a data URL (base64), return as-is
  if (url.startsWith('data:')) {
    return url;
  }
  
  // If it starts with /uploads/, prepend the backend URL
  if (url.startsWith('/uploads/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  // For other relative paths, prepend backend URL
  if (url.startsWith('/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  // Return as-is for any other case
  return url;
};

export default getImageUrl;
